import React from 'react';

import InputContainer from '../../InputContainer/input-container';

export default class Dropdown extends React.PureComponent {
	render() {
		return (
			<InputContainer
				id={this.props.id}
				inline={this.props.inline}
				label={this.props.label}
				width={this.props.width}
				labelAfterInput={this.props.labelAfterInput}
				body={
					<select
						id={this.props.id}
						value={this.props.value || ''}
						onChange={this.props.onChange}
						className="form-control">
						<option value="" disabled defaultValue>
							Country
						</option>
						{this.props.options.map((option, index) => (
							<option key={index} value={option.country_iso2}>
								{option.country}
							</option>
						))}
					</select>
				}
			/>
		);
	}
}
